<template>
  <div>
    <ExemptMfgList/>
    <ExemptMfgFooter/>
  </div>
</template>
<script>
import ExemptMfgFooter from '../../../components/tax/ExemptMfg/ExemptMfgFooter.vue';
import ExemptMfgList from '../../../components/tax/ExemptMfg/ExemptMfgList.vue';

export default {
  name: 'ExemptMfg',
  components: {
    ExemptMfgFooter,
    ExemptMfgList,
  },
};
</script>
